import { __assign } from './../../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
import FacebookUncoloredIcon from '../../../../assets/icons/facebook-uncolored.icon.js';
import TwitterIcon from '../../../../assets/icons/twitter.icon.js';
import LinkedinIcon from '../../../../assets/icons/linkedin.icon.js';
import YoutubeIcon from '../../../../assets/icons/youtube.icon.js';
import InstagramIcon from '../../../../assets/icons/instagram.icon.js';
import Icon from './../../../../external_lib/@ant-design/icons/es/components/Icon.js';

function SocialIcon(_a) {
    var media = _a.media, className = _a.className;
    var Facebook = FacebookUncoloredIcon;
    var Twitter = function (props) { return React__default.createElement(Icon, __assign({ component: TwitterIcon }, props)); };
    var Linkedin = function (props) { return React__default.createElement(Icon, __assign({ component: LinkedinIcon }, props)); };
    var Youtube = function (props) { return React__default.createElement(Icon, __assign({ component: YoutubeIcon }, props)); };
    var Instagram = function (props) { return (React__default.createElement(Icon, __assign({ component: InstagramIcon }, props))); };
    switch (media) {
        case 'facebook':
            return React__default.createElement(Facebook, { className: className });
        case 'twitter':
            return React__default.createElement(Twitter, { className: className });
        case 'linkedin':
            return React__default.createElement(Linkedin, { className: className });
        case 'youtube':
            return React__default.createElement(Youtube, { className: className });
        case 'instagram':
            return React__default.createElement(Instagram, { className: className });
        default:
            return null;
    }
}

export { SocialIcon as default };
//# sourceMappingURL=icon.component.js.map
